import type { ProcurementPlan, ProcurementPlanItem } from '@/types/api'
import { createCrudService } from '../crud'

export type ProcurementPlanItemInput = Pick<
  ProcurementPlanItem,
  'id' | 'item_type' | 'product_id' | 'product_group_id' | 'container_count'
>

export type ProcurementPlanInput = Pick<
  ProcurementPlan,
  'plan_number' | 'created_date' | 'start_date' | 'end_date' | 'note' | 'status'
> & { items: ProcurementPlanItemInput[] }

export type ProcurementPlanUpdate = Partial<ProcurementPlanInput> & { version: number }

export const procurementPlansService = createCrudService<ProcurementPlan, ProcurementPlanInput, ProcurementPlanUpdate>(
  'procurement/plans',
  { updateMethod: 'patch' },
)
